mutation BatchEditUrgentUpdate($input: BatchEditUrgentUpdateInput!) {
  batchEditUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
